import { createGlobalStyle } from 'styled-components';
// fonts
import AkzidGroProBolExtWoff from './fonts/AkzidGroProBolExt.woff';
import AkzidGroProBolExtWoff2 from './fonts/AkzidGroProBolExt.woff2';
import NmScriptWoff from './fonts/nm-script.woff';
import NmScriptWoff2 from './fonts/nm-script.woff2';
import NmSerifWoff from './fonts/nm-serif.woff';
import NmSerifWoff2 from './fonts/nm-serif.woff2';
import SourceSans3RegularWoff from './fonts/source-sans-3-regular.woff';
import SourceSans3RegularWoff2 from './fonts/source-sans-3-regular.woff2';

// 2024 rebrand base font
export const SourceSans3Regular = createGlobalStyle`
  @font-face {
    font-family: 'Source Sans';
    src: url(${SourceSans3RegularWoff2}) format('woff2'),
         url(${SourceSans3RegularWoff}) format('woff');
    font-weight: normal;
    font-display: auto;
    font-style: normal;
  }
`;

// 2024 rebrand serif font for headings
export const NmSerif = createGlobalStyle`
  @font-face {
    font-family: 'NM Serif';
    src: url(${NmSerifWoff2}) format('woff2'),
         url(${NmSerifWoff}) format('woff');
    font-weight: normal;
    font-display: auto;
    font-style: normal;
  }
`;

// 2024 rebrand handwritten font for special accenting
export const NmScript = createGlobalStyle`
  @font-face {
    font-family: 'NM Script';
    src: url(${NmScriptWoff2}) format('woff2'),
         url(${NmScriptWoff}) format('woff');
    font-weight: normal;
    font-display: auto;
    font-style: normal;
  }
`;

// used on a few pages for special use cases
export const AkzidenzGroteskProBoldExtended = createGlobalStyle`
  @font-face {
    font-family: 'akzidenz-grotesk-pro-bold-extended';
    src: url(${AkzidGroProBolExtWoff2}) format('woff2'),
         url(${AkzidGroProBolExtWoff}) format('woff');
    font-weight: normal;
    font-display: auto;
    font-style: normal;
  }
`;
